import { ExamReassignmentReadTaskPreview } from '@common/config/api/client'
import { Paper, Stack, Table, TableContainer, Typography, useTheme } from '@mui/material'
import ReassignExamTaskTableHeader from './ReassignExamTaskTableHeader'
import ReassignExamTaskReadTableBody from './ReassignExamTaskReadTableBody'

export default function ReassignExamTaskReadTable({ tasks }: { tasks: ExamReassignmentReadTaskPreview[] }) {
  const theme = useTheme()

  return (
    <Stack spacing={3}>
      <Stack>
        <Typography color="text.primary" variant="subtitle1">
          Read tasks updates
        </Typography>
        <Typography color="text.secondary" variant="body2">
          Tasks will be updated based on the new submission status
        </Typography>
      </Stack>

      <Paper
        sx={{
          borderRadius: 2,
          border: `1px solid ${theme.palette.secondary.main}`,
          overflowY: 'auto',
        }}
      >
        <TableContainer>
          <Table size="small">
            <ReassignExamTaskTableHeader />
            <ReassignExamTaskReadTableBody tasks={tasks} />
          </Table>
        </TableContainer>
      </Paper>
    </Stack>
  )
}
